import React from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { CAMPAIGN_PATH, DETAILS_PATH, STAGES_PATH } from '~/features/base/constants/routes';
import CampaignHeader from '~/features/campaigns/components/campaign/CampaignHeader';
import CampaignOverviewContainer
    from '~/features/campaigns/components/campaign/campaignDetails/CampaignOverviewContainer';
import CampaignStages from '~/features/campaigns/components/campaign/CampaignStages/CampaignStages';
import CampaignTabs from '~/features/campaigns/components/campaign/CampaignTabs';
import { Campaign } from '~/api/models/campaign';

interface CampaignContainerProps {
    canReadCampaigns?: boolean;
    match: { path: string; url: string };
    campaign: Campaign;
}

const CampaignContainer: React.FC<CampaignContainerProps> = ({
    canReadCampaigns = true,
    match,
    campaign
}) => {
    const { campaignId } = useParams();


    if (!canReadCampaigns) {
        return <FormattedMessage id='intl-msg:accessNotAllowed'/>;
    }

    return (
        <div className='campaign-container '>
            <CampaignHeader
                campaign={campaign}
            />

            <div>
                <CampaignTabs basePath={`/${CAMPAIGN_PATH}/${campaignId}`} campaign={campaign}/>
            </div>
            <Switch>
                <Route
                    path={`${match.path}/${DETAILS_PATH}`}
                    render={(props) => (
                        <CampaignOverviewContainer
                            {...props}
                            campaign={campaign}
                        />
                    )}
                />
                <Route
                    path={`${match.path}/${STAGES_PATH}`}
                    render={(props) => (
                        <CampaignStages
                            {...props}
                            campaign={campaign}
                        />
                    )}
                />

                <Redirect to={`${match.url}/${DETAILS_PATH}`}/>
            </Switch>
        </div>
    );
};

export default CampaignContainer;
